//!#system	

<template>
	<div v-if="storeDataIsLoaded">
		<v-navigation-drawer 
			v-if="preferencesAreLoaded"
			app 
			:v-model="true" 
			class="blue-grey darken-4 left-nav" 
			clipped 
			dark 
			disable-resize-watcher 
			fixed 
			overflow 
			permanent
			:mini-variant="!drawer"
		>
			<v-list nav>
				<v-list-item v-for="(item, index) in mains" :key="item.path" :to="item.path">

					<v-list-item-icon>
						<v-icon class="iconWidth">{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{item.title}}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-navigation-drawer
			app
			key="pinned-items"
			v-model="pinnedItemsDrawer"
			class="blue-grey darken-3 left-nav" 
			clipped 
			dark
			fixed
			overflow 
			:mini-variant="pinnedItemsDrawerMini"
			right
		>
			<v-btn text small icon @click="pinnedItemsDrawerMini = !pinnedItemsDrawerMini"><v-icon x-small class="iconWidth">{{pinButtonExpander}}</v-icon></v-btn>
			<v-list nav>
				<v-list-item v-for="pin in pins" :key="'pin=' + pin.path" :to="pin.path" :exact="true">
					<v-list-item-icon>
						<v-tooltip left>
							<template v-slot:activator="{ on }">
								<v-icon v-on="on" class="iconWidth">{{pin.icon}}</v-icon>
							</template>
							<span>{{pin.tooltip}}</span>
						</v-tooltip>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{pin.name}}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
		<v-app-bar app color="black" dark fixed clipped-left clipped-right>
			<v-app-bar-nav-icon @click="toggleDrawer"></v-app-bar-nav-icon>
			<v-spacer class="hidden-md-and-up"></v-spacer>
			<router-link v-bind:to="appHome">
				<app-logo />
			</router-link>
			<v-spacer class="hidden-sm-and-down"></v-spacer>
			<v-toolbar-items>
				<v-btn v-for="item in mains" :key="item.path" v-if="item.top === true" text class="hidden-sm-and-down" v-bind:to="item.path">{{item.title}}</v-btn>

				<v-tooltip bottom v-if="searchDrawers.main">
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" text @click="openMainSearchPanel">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
					</template>
					<span>Open quick-search (type "/")</span>
				</v-tooltip>

				<v-tooltip bottom v-if="preferencesAreLoaded">
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" text @click="togglePinsDrawer" :loading="pinDrawerLoading" class="hidden-sm-and-down">
							<v-icon :color="pinnedItemsDrawer ? 'primary' : ''">mdi-pin-outline</v-icon>
						</v-btn>
					</template>
					<span>{{pinnedItemsDrawer ? 'Close your pinned items' : 'Open your pinned items'}}</span>
				</v-tooltip>

				<v-tooltip bottom v-if="preferencesAreLoaded && currentRoute === 'dashboard'">
					<template v-slot:activator="{ on }">
						<v-btn @click="getDashboards" v-on="on" text>
							<v-icon>mdi-view-dashboard-variant</v-icon>
						</v-btn>
					</template>
					<span>Change dashboard</span>
				</v-tooltip>
			</v-toolbar-items>
			<v-spacer class="hidden-md-and-up"></v-spacer>
			<user v-if="preferencesAreLoaded" />
			<v-menu left bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>more_vert</v-icon>
					</v-btn>
				</template>
				<v-list class="black" dark>
					<v-list-item v-for="(item, index) in items" :key="index" @click="navigate(item)">
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>

		<!-- search panel -->
		<v-navigation-drawer
			v-for="panel in searchDrawers.panels"
			:key="panel.namespace + '.' + panel.name + '-panel-' + panel.open + recentFetched"
			v-model="panel.open"
			right
			fixed
			temporary
			width="400"
		>
			<div>
				<v-form class="my-2 mx-2" @submit="doQuickSearch">
					<v-text-field 
						v-model="searchString"
						label="Search" 
						:hint="searchHint(panel)" 
						:autofocus="true"
						class="mb-4"
					/>
					<v-menu offset-y offset-x>
						<template v-slot:activator="{ on }">
							<v-btn class="float-right" small text v-on="on">
								<v-icon>more_vert</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item @click="checkGate" :disabled="!searchString">
								<v-list-item-title>
									Check the duplicate gate
								</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-btn type="submit" color="primary" @click="doQuickSearch">Search</v-btn>
				</v-form>
				<v-progress-linear v-if="gateDataLoading" indeterminate color="teal" />
				<div v-if="gateData && gateData.uniqueValue" class="pa-4">
					<v-alert
						type="warning"
					>
						<v-row align="center">
							<v-col class="grow">
								"{{gateData.uniqueValue}}" is a gated value. It is protected from duplicates, but you can remove the gate here.
							</v-col>
							<v-col class="shrink" x-small>
								<v-btn @click="removeGate">Remove gate</v-btn>
							</v-col>
						</v-row>
					</v-alert>
				</div>
				<div v-if="gateData && gateData.error" class="pa-4">
					<v-alert
						type="warning"
					>
						{{gateData.error}}
					</v-alert>
				</div>
				<div v-if="recents[searchDrawers.current]">
					<v-list shaped>
						<v-subheader>RECENT</v-subheader>
						<v-list-item-group v-model="recent" color="primary">
							<v-list-item
								v-for="recent in recents[searchDrawers.current]"
								:key="recent.id + '-recent'"
								@click="goToRecent(recent)"
							>
								<v-list-item-icon v-if="icons[searchDrawers.current]">
									<v-icon small v-text="icons[searchDrawers.current]"></v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title v-text="recentLinkText(panel, recent)"></v-list-item-title>
									<v-list-item-subtitle class="caption" v-if="recentSubtitleKey">{{recent[recentSubtitleKey]}}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</div>
			</div>
		</v-navigation-drawer>
		<v-dialog v-model="dashboardChooserDialog" max-width="500">
			<v-card :loading="dashboardListLoading" elevation="0" color="transparent">
				<v-card>
					<v-card-title>Choose a dashboard</v-card-title>
					<v-card-text>
						<v-container fluid>
							<v-row dense>
								<v-col
									v-for="dash in dashboardList" :key="dash.id"
									:cols="12" 
									lg="6"
									md="6"
									sm="6"
									xs="12"
								>
									<v-card @click="changeDashboard(dash)" class="pa-4">
										{{dash.dashboardKey}}
									</v-card>
								</v-col>
							</v-row>
						</v-container>
					</v-card-text>
				</v-card>
			</v-card>
		</v-dialog>
	</div>
	<div v-else>
		<v-overlay>
			<v-progress-circular
				indeterminate
				size="64"
			></v-progress-circular>
		</v-overlay>
	</div>
</template>
<script>
import store from '@/store';
import tools from '@/tools';
import apiService from '@/apiService';
import router from '@/router';
import series from 'to-series';
import AppLogo from '@/components/AppLogo';
import User from '@/components/pieces/User';
import GetVarsMixins from '@/GetVarsMixins';
import PgtUtilMix from '@/PgtUtilMix';

// TODO: show "recent" objects in the panel
// TODO: keyboad shortcut '/' to open the main panel

export default {
	name: 'AppNavigation',
	mixins: [GetVarsMixins, PgtUtilMix],
	components: {
		AppLogo,
		User
	},

	data() {
		return {
			appTitle: this.$store.state.app.appName,
			searchString: '',
			recents: {},
			icons: {},
			recent: '',
			recentSubtitleKey: '',
			recentFetched: tools.randomString(),
			gateData: null,
			quickSearchLoading: false,
			gateDataLoading: false,
			pinnedItemsDrawerMini: true,
			pinDrawerLoading: false,
			dashboardChooserDialog: false,
			dashboardListLoading: false,
			dashboardList: []
		};
	},
	methods: {
		navigate(item) {
			router.push(item.path);
		},
		toggleDrawer() {
			this.$store.dispatch('app/toggleDrawer');
		},
		openMainSearchPanel() {
			this.gateData = null;
			if (this.searchDrawers.main) {
				this.$store.dispatch('app/openSearchPanel', this.searchDrawers.main);
				this.recentObjects();
			}
		},
		closeMainSearchPanel() {
			if (this.searchDrawers.main) {
				this.$store.dispatch('app/closeSearchPanel', this.searchDrawers.main);
			}
		},
		doQuickSearch(e) {
			if (e) e.preventDefault();
			const routeInfo = this.currentSearchPanel;
			// TODO: Do a 'get' call on this first.  If nothing is returned, then go to list
			const listFilter = {};
			const str = this.searchString.trim();
			listFilter[routeInfo.fieldName] = str;
			this.quickSearchLoading = true;
			apiService.list({ ...routeInfo, filters: listFilter }, (err, results) => {
				this.quickSearchLoading = false;
				if (err) {
					return this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err 
					});
				} else if (results.length === 1) {
					this.searchString = '';
					return tools.goToDetail({ ...routeInfo, id: results[0].id });
				} else {
					const filters = {};
					filters[routeInfo.fieldName] = { 
						name: routeInfo.fieldName,
						operator: routeInfo.fieldOp || 'bw', 
						value: this.searchString 
					};
					return tools.goToList(routeInfo, { 
						filters
					});
				}
			});
		},
		goToRecent(recent) {
			tools.goToDetail(this.currentSearchPanel, recent.id);
		},
		getContexts() {
			series()
				.first(cb => {
					if (store.state.authentication.isAuthenticated) return cb();
					return cb(new Error('Not authenticated.'));
				})
				.next(cb => {
					this.$store.dispatch('authentication/userIsAdmin', { callback: cb });
				})
				.end(() => {
					if (store.state.authentication.isAuthenticated) {
						this.$store.dispatch('app/getMainContext');
						this.$store.dispatch('app/getSettingContext');
						this.$store.dispatch('app/getSearchContext');
						this.$store.dispatch('app/getVersionData');
						if (this.isAdmin) this.$store.dispatch('app/getAdminContext');
					}
				});
		},
		searchHint(panel) {
			return tools.camelToTitle(panel.pluralName) + ' / ' + tools.camelToTitle(panel.fieldName);
		},
		recentLinkText(panel, dataItem) {
			return dataItem[panel.fieldName];
		},
		recentObjects() {
			if (!this.searchDrawers.current) return;
			let recentCount = 0;
			if (this.recents[this.searchDrawers.current]) recentCount = this.recents[this.searchDrawers.current].length;
			this.$store.dispatch('app/fieldInfo', {
				routeInfo: this.currentSearchPanel,
				callback: (err, fieldInfoResponse) => {
					if (!err) this.icons[this.searchDrawers.current] = fieldInfoResponse.icon;
					fieldInfoResponse.fields.forEach(field => {
						if (field.subtitle) {
							this.recentSubtitleKey = field.name;
						}
					});
				}
			});
			apiService.list({ ...this.currentSearchPanel, filters: { _recent_: true } }, (err, response) => {
				if (err) {
					this.recents[this.searchDrawers.current] = [];
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err 
					});
				} else {
					this.recents[this.searchDrawers.current] = response;
					if (response.length !== recentCount) this.recentFetched = tools.randomString();
				}
			});
		},
		checkGate() {
			const searchString = (this.searchString || '').trim();
			this.gateDataLoading = true;
			apiService.call({
				method: 'post',
				path: '/' + encodeURIComponent(tools.camelCaseToDash(this.currentSearchPanel.namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(this.currentSearchPanel.pluralName)) + '/action/check-gate',
				body: {
					uniqueValue: searchString
				}
			}, (err, response) => {
				this.gateDataLoading = false;
				if (err) {
					this.gateData = { error: err.message };
					return;
				}
				if (response && Object.keys(response).length) {
					this.gateData = response;
					return;
				}
				this.gateData = { error: `${searchString} is not gated.` };
			});
		},
		removeGate() {
			const searchString = (this.searchString || '').trim();
			apiService.call({
				method: 'post',
				path: '/' + encodeURIComponent(tools.camelCaseToDash(this.currentSearchPanel.namespace)) + '/' + encodeURIComponent(tools.camelCaseToDash(this.currentSearchPanel.pluralName)) + '/action/remove-gate',
				body: {
					uniqueValue: searchString
				}
			}, (err, response) => {
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: 'There was an error removing the gate.' 
					});
					return;
				}
				this.gateData = null;
				this.$store.dispatch('app/applyObjectUpdated', {
					show: true,
					text: 'The gate was removed.' 
				});
			});
		},
		togglePinsDrawer() {
			this.pinDrawerLoading = true;
			this.$store.dispatch('authentication/changePinSetting', { 
				pinSetting: !this.pinnedItemsDrawer,
				callback: err => {
					this.pinDrawerLoading = false;
				}
			});
		},
		getDashboards() {
			this.dashboardListLoading = true;
			this.dashboardChooserDialog = true;
			apiService.list({
				namespace: 'system',
				pluralName: 'dashboards'
			}, (err, response) => {
				this.dashboardListLoading = false;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err
					});
					return;
				} else {
					this.dashboardList = response;
				}
			});
		},
		changeDashboard(dash) {
			this.$store.dispatch('app/setDashboard', { dashboard: dash });
			this.dashboardChooserDialog = false;
			const prefsToMerge = {
				dashboardKey: dash.dashboardKey
			};
			this.$store.dispatch('authentication/setPrefs', { prefsToMerge, callback: () => {}});
		}
	},
	computed: {
		storeDataIsLoaded() {
			return this.$store.getters['authentication/isLoaded'] && this.$store.getters['app/isLoaded']
		},
		preferencesAreLoaded() {
			return this.$store.getters['authentication/userPrefsAreLoaded']
		},
		drawer: {
			get: () => {
				return store.state.app.mainDrawer
			},
			set: () => {}
		},
		pinnedItemsDrawer: {
			get: function() {
				return this.$store.getters['authentication/pins'];
			},
			set: function() {
			}
		},
		currentSearchPanel() {
			let current = {};
			this.searchDrawers.panels.forEach(panel => {
				if (this.searchDrawers.current === panel.namespace + '.' + panel.name) {
					current = { ...panel };
				}
			});
			return current;
		},
		searchPanelIsOpen() {
			for (let i = 0; i < this.searchDrawers.panels.length; i++) {
				if (this.searchDrawers.panels[i].open) return true;
			}
			return false;
		},
		searchDrawers() {
			return store.state.app.searchObjects;
		},
		isAuthenticated() {
			return store.state.authentication.isAuthenticated;
		},
		isAdmin() {
			return store.state.authentication.isAdmin;
		},
		appHome() {
			if (store.state.authentication.isAuthenticated) {
				return '/dashboard';
			} else {
				return '/';
			}
		},
		pinButtonExpander() {
			return this.pinnedItemsDrawerMini ? 'mdi-chevron-double-left' : 'mdi-chevron-double-right';
		},
		mains() {
			if (store.state.authentication.isAuthenticated) {
				let navItems = [];
				if (!Array.isArray(store.state.app.mains)) return [];
				store.state.app.mains.forEach(main => {
					main.dashedPluralName = tools.camelCaseToDash(main.pluralName);
					navItems.push({
						path: `/app/${main.namespace}/${main.dashedPluralName}` + ( main.defaultListQuery || '' ),
						title: tools.camelToTitle(main.pluralName),
						flat: true,
						icon: main.icon,
						top: main.top || false
					})
				});
				return navItems;
			} else {
				return [{
						path: '/sign-in',
						title: 'Sign in',
						flat: true,
						top: true
					},
					{
						path: '/register',
						title: 'Register',
						color: 'blue-grey lighten-1',
						top: true
					}
				];
			}
		},
		items() {
			if (store.state.authentication.isAuthenticated) {
				let navItems = [];
				navItems.push({
					path: '/sign-out',
					title: 'Sign out',
					color: 'blue-grey lighten-1'
				});
				navItems.push({
					path: '/app/settings',
					title: 'Settings',
					color: 'blue-grey lighten-1',
					noDrawer: true
				});
				if (store.state.authentication.isAdmin) {
					navItems.push({
						path: '/app/admin',
						title: 'Admin',
						color: 'blue-grey lighten-1',
						noDrawer: true
					});
				}
				return navItems;
			} else {
				return [{
						path: '/sign-in',
						title: 'Sign in',
						flat: true,
						top: true
					},
					{
						path: '/register',
						title: 'Register',
						color: 'blue-grey lighten-1',
						top: true
					}
				];
			}
		},
		pins() {
			return this.$store.getters['authentication/openPins'];
		},
		currentRoute() {
			return this.$route.name;
		}
	},
	watch: {
		isAuthenticated(newVal, oldVal) {
			if (newVal) {
				this.getContexts();
			}
		},
		isAdmin(newVal, oldVal) {
			if (newVal) {
				this.getContexts();
			}
		}
	},
	mounted() {
		this._keyListener = function(e) {
			const activeElement = document.activeElement;
			if (['text', 'textarea', 'password'].includes(activeElement.type)) return; // do not do anything if typing in a box
			try {
				if (activeElement.classList.includes('language-text')) return; // do not do anything if typing in a code editor
			} catch(err) {}
			if (e.key === '/' && !this.searchPanelIsOpen) {
				if (!(activeElement && activeElement.type === 'text')) e.preventDefault(); // Don't type a '/' in the search-box
				this.openMainSearchPanel();
			}
			if (e.key === 'Escape' && this.searchPanelIsOpen) {
				this.closeMainSearchPanel();
			}
		};
		document.addEventListener('keydown', this._keyListener.bind(this));
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this._keyListener);
	},
	created() {
		const publicRoutes = [
			'/',
			'/activate',
			'/sign-in',
			'/register',
			'/password-reset'
		];

		this.$store.dispatch('authentication/userLoad', {
			callback: (err, response, meta) => {
				if (err) {
					this.$store.dispatch('authentication/setLoaded');
					this.$store.dispatch('app/setLoaded');
					// Don't display error if it's a public route -- user doesn't need to be authenticated for these
					if (!publicRoutes.includes(tools.currentPage())) {
						this.$store.dispatch('app/applyObjectError', {
							show: true,
							text: ( meta && meta.validation ? meta.validation.messages.join('\r\n') : 'You are not logged in.  Please log in again.')
						});
					}
				} else {
					this.$store.dispatch('app/clearObjectError', {});
					this.$store.dispatch('authentication/getPrefs', { callback: () => {
						this.$store.dispatch('authentication/setPrefs', { prefsToMerge: {}, callback: () => {
							if (this.$store.state.authentication.preferences.dashboardKey) {
								this.$store.dispatch('app/setDashboard', { dashboard: { dashboardKey: this.$store.state.authentication.preferences.dashboardKey } });
							}
							this.$store.dispatch('app/fetchCustomFieldInfo', { callback: () => {
									this.pinnedItemsDrawer = this.$store.getters['authentication/pins'];
									this.$store.dispatch('authentication/setLoaded');
									this.$store.dispatch('app/setLoaded');
								}
							});
						}});
					}});
					const getVars = this.getVars();
					if (['/sign-in', '/'].includes(tools.currentPage())) {
						if (getVars.goto && getVars.goto.startsWith('/')) {
							window.location.href = this.goto;
						} else {
							return router.push('/dashboard');
						}
					}
					router.push(tools.currentPage(true) || '/dashboard');
					this.recentObjects();
				}
			}
		});
	}
};
</script>
<style scoped>
a {
	color: white !important;
	text-decoration: none;
}

a div {
	color: white;
	text-decoration: none;
}

.v-toolbar__title,
a {
	font-family: "Montserrat" !important;
}

.left-nav .v-list-item__content {
	margin-left: -18px;
}

.left-nav .v-list-item__icon {
	width: 30px;
}

.iconWidth {
	width: 30px;
}
</style>